module.exports = __webpack_public_path__ + "assets/img/right_1.136083ed.png";